import { React, useState, useEffect, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Button,
  Icon,
  Table,
  Pagination,
  Dropdown,
  Input,
  Form,
  Confirm,
  Divider,
  Modal,
} from 'semantic-ui-react'
import Proptypes from 'prop-types'
import { RefreshUserCustomersList } from '../../../../redux/actions/customer'
import styles from '../customer-info-view/customer-view.module.css'
import { CustomerViewContext } from '../customer-info-view/customerView'
import classes from './customerList.module.css'
import IntelMsg from '../../../ItelMsg'
import { primaryColor } from '../../../../constants'
import { history } from '../../../../redux/store'
import {
  changeCustomerStatus,
  GetCustomerInfo,
  GetPaginationCustomersList,
  GetPaginationCustomersListWithSearch,
} from '../../../../services/customer/index'
import StatusDialog from '../../../status-dialog'

// eslint-disable-next-line no-unused-vars
const CustomersList = ({ fromHierarchy }) => {
  const [customerList, setCustomerList] = useState([])
  const [noOfPages, setNoOfPages] = useState(0)
  const [showStatusDialog, setShowStatusDialog] = useState(false)
  const [dialogContent, setDialogContent] = useState(<></>)
  const [pageSize] = useState(10)
  const [activePage, setActivePage] = useState(0)
  const [open, setOpen] = useState(false)
  const [itemData, setItemData] = useState()
  const [confirm, setConfirm] = useState(false)
  const [openDelete, setOpenDeleteModal] = useState(false)

  const criteria = [
    { key: 1, text: 'Name', value: 'name' },
    { key: 2, text: 'Status', value: 'status' },
  ]
  const Status = [
    { key: 1, text: 'Active', value: 'Active' },
    { key: 2, text: 'Inactive', value: 'Inactive' },
  ]
  const dispatch = useDispatch()

  const [searchTerm, setSearchTerm] = useState('')
  const [searchCriteria, setSearchCriteria] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [searchStatus, setSearchStatus] = useState('')
  const [searchName, setSearchName] = useState('')
  const {
    setViewCustomer,
    setCustomerData,
    setViewNetworkSettings,
    setCustomerSettings,
    setViewHierarchy,
  } = useContext(CustomerViewContext)
  const productName = localStorage.getItem('product')
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const handleChange = (event) => {
    setSearchTerm(event.target.value.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, ''))
  }

  const handleReset = () => {
    setSearchTerm('')
    setSearchCriteria('')
  }

  const handleSelect = (e) => {
    setSearchCriteria(e.target.outerText.toLocaleLowerCase())
    setSearchTerm(searchTerm)
    setSearchName(searchTerm)

    setSearchStatus(searchTerm)
    if (searchCriteria === 'name' || searchCriteria === 'status') {
      setSearchTerm('')
      setSearchName('')
    }
  }
  const handleStatusSelect = (e, data) => {
    console.log('e.target.outerTex', data.value)

    setSearchTerm(data.value)
  }
  useEffect(() => {
    const results = customerList.filter((item) =>
      item.title === searchTerm ? console.log('found') : null,
    )

    setSearchResults(results)
    console.log('Search Result : ', searchResults)

    if (searchCriteria === 'status') {
      setSearchStatus(`${searchTerm}`)
    } else if (searchCriteria === 'name') {
      setSearchName(`${searchTerm}`)
    } else {
      setSearchStatus('')
      setSearchName('')
    }
  }, [searchTerm, searchCriteria])
  // TODO refresh asset list

  const { refreshCustomerList } = useSelector((store) => ({
    refreshCustomerList: store.customer.refreshCustomerList,
  }))

  useEffect(() => {
    if (refreshCustomerList) {
      console.log('refresh', refreshCustomerList)

      GetPaginationCustomersList(
        userEmail,
        productName,
        activePage,
        pageSize,
      ).then((data) => {
        console.log('data', data)
        setCustomerList(data.data)
        setNoOfPages(data['no of pages'])
      })
    }
    dispatch(RefreshUserCustomersList(false))
  }, [refreshCustomerList])

  useEffect(() => {
    console.log('email refreshCustomerList', refreshCustomerList)
    if (userEmail) {
      if (
        searchTerm.split(' ').join('') !== '' &&
        searchCriteria === 'status'
      ) {
        GetPaginationCustomersListWithSearch(
          userEmail,
          productName,
          null,
          activePage,
          pageSize,
          searchTerm || 'Active',
        ).then((data) => {
          setCustomerList(data.data)
          console.log('data.data', data.data)
          setNoOfPages(data['no of pages'])
          setSearchStatus(searchTerm)
          // dispatch(RefreshUserCustomersList(true))
        })
      } else if (
        searchTerm.split(' ').join('') !== '' &&
        searchCriteria === 'name'
      ) {
        console.log('nameSearchCriteria')
        GetPaginationCustomersListWithSearch(
          userEmail,
          productName,
          searchName.split(' ').join(''),
          activePage,
          pageSize,
          null,
        ).then((data) => {
          console.log('dataaa: ', data)
          setCustomerList(data.data || [])
          console.log('customerList', customerList.length)

          setNoOfPages(data['no of pages'])
          setSearchName(searchTerm)
          // dispatch(RefreshUserCustomersList(true))
        })
      } else {
        GetPaginationCustomersList(
          userEmail,
          productName,
          activePage,
          pageSize,
        ).then((data) => {
          console.log('data length', data)
          setCustomerList(data.data)
          setNoOfPages(data['no of pages'])
          // dispatch(RefreshUserCustomersList(true))
        })
      }
    }
  }, [userEmail, activePage, searchStatus, searchName])

  function filteringCriteria(prop) {
    if (searchCriteria === 'status') {
      return prop.status.includes(searchTerm)
    }
    if (searchCriteria === 'name') {
      if (prop.title) {
        return prop.title
          .toUpperCase()
          .includes(searchTerm.toUpperCase().split(' ').join(''))
      }
    }
    return prop.title
      .toLocaleLowerCase()
      .includes(searchTerm.toLocaleLowerCase().split(' ').join(''))
  }

  const getDialogContent = (success, msg) => {
    if (success) {
      return (
        <>
          <Icon name="check" size="large" color="green" />
          <div style={{ fontSize: 'large' }}>{msg}</div>
        </>
      )
    }
    return (
      <>
        <Icon name="exclamation triangle" size="large" color="red" />
        <div style={{ fontSize: 'large' }}>{msg}</div>
      </>
    )
  }
  const handleConfirm = () => {
    setConfirm(true)
    setOpenDeleteModal(false)
    dispatch(RefreshUserCustomersList(true))
  }
  useEffect(() => {
    console.log('itemmm: ', itemData)
    dispatch(RefreshUserCustomersList(false))

    if (confirm) {
      setOpen(false)
      let content = <></>
      try {
        const response = changeCustomerStatus(
          productName,
          itemData.title,
          itemData.tbCustomerId,
        )

        if (response.success) {
          setCustomerList([])
          setNoOfPages(0)
          // content = getDialogContent(
          //   true,
          //   response.message ? response.message : 'Status changed!',
          // )
          // GetPaginationCustomersList(
          //   userEmail,
          //   productName,
          //   activePage,
          //   pageSize,
          // ).then((data) => {
          //   console.log('data', data)
          //   setCustomerList(data.data)
          //   setNoOfPages(data['no of pages'])
          // })
          setConfirm(false)
          setOpen(false)
          setDialogContent(content)
          setShowStatusDialog(true)
          dispatch(RefreshUserCustomersList(true))
        } else {
          setConfirm(false)
          setOpen(false)
          let { msg } = response
          msg = Array.isArray(msg)
            ? msg.map((error) => <div>{error}</div>)
            : msg
          content = getDialogContent(false, msg || 'Status Changed!')

          setDialogContent(content)
          setShowStatusDialog(true)
          dispatch(RefreshUserCustomersList(true))
        }
      } catch (e) {
        setConfirm(false)
        setOpen(false)
        let { msg } = e
        msg = Array.isArray(msg)
          ? msg.map((error) => (
              <>
                <div>{error}</div>
                <br />
              </>
            ))
          : msg
        setDialogContent(getDialogContent(false, msg || 'Customer Not Changed'))
        setShowStatusDialog(true)
      }
    }
  }, [confirm])

  const handleCancel = () => setOpen(false)
  const onDetailsClick = async (item) => {
    console.log('customerrr: ', item)
    try {
      const customerData = await GetCustomerInfo(
        userEmail,
        item.title,
        productName,
      )
      console.log('customerData', customerData)
      setCustomerData(customerData)
      setViewCustomer(true)
      dispatch(RefreshUserCustomersList(true))
    } catch (e) {
      setDialogContent(
        <>
          <Icon name="exclamation triangle" size="huge" color="red" />
          <p style={{ fontSize: 'x-large' }}>{e.message}</p>
        </>,
      )
      setShowStatusDialog(true)
    }
  }
  const onChange = (e, pageInfo) => {
    console.log('pageInfo', e)
    setActivePage(pageInfo.activePage - 1)
  }
  const confirmHeader = (
    <div
      style={{
        height: '53px',
        paddingLeft: '15px',
        backgroundColor: '#f33b12',
        paddingTop: '21px',
        fontSize: '13pt',
        color: 'white',
      }}
    >
      <Icon name="archive" size="large" color="white" />
      Customer Activation Alert
      <Divider horizontal></Divider>
    </div>
  )
  const confirmContent = (
    <div
      style={{
        margin: '0',
        top: '50%',
        height: '50px',
        width: '100%',
        fontSize: '10pt',
        lineHeight: '1.4',
        padding: '1.5rem',
        color: 'black',
      }}
    >
      <strong>Are you sure!</strong>
    </div>
  )

  const openCustomerSettings = (item) => {
    setViewNetworkSettings(true)
    setCustomerSettings(item)
  }

  const openHierarchy = (item) => {
    setCustomerSettings(item)
    setViewHierarchy(true)
  }

  const listItems =
    customerList.length > 0 ? (
      customerList
        .filter((item) => filteringCriteria(item))
        .map((item) => (
          <Table.Row key={item.title}>
            <Table.Cell width={5}>{item.title}</Table.Cell>
            <Table.Cell width={5}>{item.status}</Table.Cell>
            <Table.Cell width={6}>
              {!fromHierarchy && (
                <>
                  <Button
                    animated
                    size="medium"
                    onClick={() => onDetailsClick(item)}
                  >
                    <Button.Content hidden>
                      <IntelMsg id="Details" />
                    </Button.Content>
                    <Button.Content visible style={{ width: '50px' }}>
                      <Icon name="ellipsis horizontal" />
                    </Button.Content>
                  </Button>
                  <Button
                    animated
                    size="medium"
                    onClick={() => {
                      setItemData(item)
                      setOpenDeleteModal(true)
                    }}
                  >
                    <Button.Content hidden style={{ width: '85px' }}>
                      {item.status === 'Inactive'
                        ? ' Activate '
                        : ' Deactivate'}
                    </Button.Content>
                    <Button.Content visible style={{ width: '50px' }}>
                      <Icon name="recycle" />
                    </Button.Content>
                  </Button>
                </>
              )}

              {productName !== 'cold' && (
                <>
                  {!fromHierarchy && (
                    <Button
                      animated
                      size="medium"
                      onClick={() => openCustomerSettings(item)}
                    >
                      <Button.Content hidden>
                        <IntelMsg id="CustomerSettings" />
                      </Button.Content>
                      <Button.Content visible style={{ width: '50px' }}>
                        <Icon name="setting" />
                      </Button.Content>
                    </Button>
                  )}

                  {fromHierarchy && (
                    <Button
                      animated
                      size="medium"
                      onClick={() => openHierarchy(item)}
                    >
                      <Button.Content hidden>
                        <IntelMsg id="Hierarchy" />
                      </Button.Content>
                      <Button.Content visible style={{ width: '50px' }}>
                        <Icon name="settings" />
                      </Button.Content>
                    </Button>
                  )}
                </>
              )}
            </Table.Cell>
          </Table.Row>
        ))
    ) : (
      <Table.Row>
        <Table.Cell colSpan="3">
          <p style={{ textAlign: 'center' }}>
            <strong>
              <IntelMsg id="thereIsNoCustomersToShow" />
            </strong>
          </p>
        </Table.Cell>
      </Table.Row>
    )

  // const handleDelete = () => {
  //   handleConfirm()
  // }

  return (
    <>
      <Form>
        <Form.Group
          inline
          widths="equals"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Form.Field width={10}>
            <span style={{ marginRight: '5px' }}>
              Select Your Search Criteria{' '}
            </span>
            <Dropdown
              // style={{ width: '400px', height: 20 }}
              clearable
              options={criteria}
              selection
              placeholder="Select Your Search Criteria"
              onChange={(e) => handleSelect(e)}
            />{' '}
          </Form.Field>
          <Form.Field width={6}>
            {searchCriteria === 'status' ? (
              <Dropdown
                clearable
                options={Status}
                selection
                placeholder="Criteria"
                onChange={handleStatusSelect}
              />
            ) : (
              <Input
                icon="users"
                labelPosition="right corner"
                type="text"
                placeholder="Search for Customer with name"
                value={searchTerm}
                onChange={handleChange}
                disabled={!searchCriteria}
              />
            )}
            <Button
              primary
              onClick={handleReset}
              // style={{ width: 94, height: 40 }}
              floated="right"
              type="submit"
            >
              Clear
            </Button>
          </Form.Field>
        </Form.Group>
      </Form>

      <div className={styles.container}>
        <IntelMsg id="customersList" />
      </div>
      <Table compact celled striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={{ textAlign: 'center' }}>
              <IntelMsg id="customerName" />
            </Table.HeaderCell>
            <Table.HeaderCell style={{ textAlign: 'center' }}>
              <IntelMsg id="Status" />
            </Table.HeaderCell>
            <Table.HeaderCell style={{ textAlign: 'center' }}>
              <IntelMsg id="actions" />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body
          className={classes.tableBody}
          style={{ textAlign: 'center' }}
        >
          <>
            {listItems}
            {/* {listItems.length < pageSize &&
              Array.from('x'.repeat(pageSize - listItems.length)).map(
                (i, idx) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Table.Row key={idx}>
                    <Table.Cell>&nbsp;</Table.Cell>
                    <Table.Cell style={{ padding: '11px' }}>&nbsp;</Table.Cell>
                    <Table.Cell>&nbsp;</Table.Cell>
                  </Table.Row>
                ),
              )} */}
          </>
        </Table.Body>
      </Table>
      <Table.Footer className={classes.footer} colSpan={2}>
        <Pagination
          floating="right"
          activePage={activePage + 1}
          onPageChange={(e, data) => onChange(e, data)}
          totalPages={noOfPages}
          firstItem={{
            content: <Icon name="angle double left" />,
            icon: true,
          }}
          lastItem={{
            content: <Icon name="angle double right" />,
            icon: true,
          }}
          prevItem={{ content: <Icon name="angle left" />, icon: true }}
          nextItem={{ content: <Icon name="angle right" />, icon: true }}
        />
      </Table.Footer>
      <StatusDialog
        showDialog={showStatusDialog}
        setShowDialog={setShowStatusDialog}
        dialogHeader={<IntelMsg id="Customer" />}
        dialogContent={dialogContent}
      />
      <Confirm
        style={{ fontSize: '10pt' }}
        open={open}
        header={confirmHeader}
        content={confirmContent}
        cancelButton="No"
        confirmButton="Yes"
        onCancel={handleCancel}
        onConfirm={handleConfirm}
      />
      <Modal
        size="small"
        open={openDelete}
        style={{ position: 'relative', height: 'auto' }}
      >
        <Modal.Header className={styles.header}>Are you sure!</Modal.Header>
        <Modal.Content image style={{ alignItems: 'center' }}>
          <Icon name="warning circle" size="huge" />
          <p style={{ fontSize: 'x-large' }}>
            <IntelMsg id="Are you Sure You Want To Change Customer Status?" />
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={handleConfirm}>
            <IntelMsg id="yes" />
          </Button>
          <Button
            className={styles.positiveStatus}
            onClick={() => setOpenDeleteModal(false)}
          >
            <IntelMsg id="no" />
          </Button>
        </Modal.Actions>
      </Modal>
      <div className={styles.actions}>
        <Button
          form="customerSettings"
          type="submit"
          style={{ backgroundColor: primaryColor, color: 'white' }}
          onClick={() => {
            if (productName === 'tank') history.push('/Tank')
            else history.push('/cold')
          }}
        >
          <Icon name="arrow left" />
          <IntelMsg id="back" />
        </Button>
      </div>
    </>
  )
}

CustomersList.propTypes = {
  fromHierarchy: Proptypes.bool,
}
export default CustomersList
